/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { makeVideoGalleryDataBuilder } from '../../../utils/videoGallery';

export default class VideoGallery extends Component {
  constructor(props) {
    super(props);
    this.initCarousel = this.initCarousel.bind(this);
    this.setVideos = this.setVideos.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.pauseCurrentVideo = this.pauseCurrentVideo.bind(this);
    this.state = {
      videosData: [],
      currentVideo: {},
      startIndex: 0,
      videoPlaying: false,
    };
  }

  async componentDidMount() {
    await this.setVideos();
    this.initCarousel();
  }

  handleClick(videoParam, index) {
    this.setState(oldState => ({
      ...oldState,
      currentVideo: videoParam,
      startIndex: index,
      videoPlaying: true,
    }));
  }

  async setVideos() {
    const { videos } = this.props;

    const videosDataPromise = videos.map(async video => {
      const videoGalleryDataBuilder = makeVideoGalleryDataBuilder();
      const videoDataPromise = await videoGalleryDataBuilder.getVideoData(
        video,
      );

      return videoDataPromise;
    });

    const resolvedVideosData = await Promise.all(videosDataPromise);

    await this.setState(oldState => ({
      ...oldState,
      videosData: resolvedVideosData,
    }));
  }

  initCarousel() {
    const carousel = window.makeCarousel(this.carouselRef, {
      perPage: 1,
      perMove: 1,
      pagination: true,
      lazyLoad: 'nearby',
      preloadPages: 0,
      start: this.state.startIndex,
      classes: {
        arrows: 'splide__arrows',
        arrow: 'splide__arrow',
        prev: 'splide__arrow--prev',
        next: 'splide__arrow--next',
      },
    });

    carousel.on('move', () => {
      this.pauseCurrentVideo();
    });

    return carousel;
  }

  iframeUrl(src) {
    const iframeSettings = '&frameborder=0&enablejsapi=1';

    return `${src}${iframeSettings}`;
  }

  pauseCurrentVideo() {
    if (!this.iframeRef) return;

    this.iframeRef.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo"}',
      '*',
    );
  }

  render() {
    const { videosData } = this.state;

    return (
      <div className="splide-wrapper container">
        <section
          className="splide videos-carousel"
          aria-label="Galeria de vídeos. Clique em um vídeo para inicia-lo."
          ref={node => {
            this.carouselRef = node;
          }}
        >
          <div className="splide__arrows splide__arrows--ltr">
            <button type="button" className="splide__arrow splide__arrow--prev">
              <i className="icon icon-arrow-left" />
            </button>
            <button type="button" className="splide__arrow splide__arrow--next">
              <i className="icon icon-arrow-right" />
            </button>
          </div>
          <div className="splide__track">
            <ul className="splide__list">
              {videosData.map((videoItem, index) => (
                <li className="splide__slide">
                  {videoItem === this.state.currentVideo ? (
                    <iframe
                      className="videos-carousel__iframe"
                      src={this.iframeUrl(videoItem.embedURL)}
                      title="YouTube video player"
                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay"
                      allowfullscreen
                      ref={node => {
                        this.iframeRef = node;
                      }}
                    />
                  ) : (
                    <div>
                      <img
                        src={`https://i.ytimg.com/vi_webp/${videoItem.id}/sddefault.webp`}
                        alt="Imagem do veículo"
                        className="gallery-image"
                        loading="lazy"
                      />
                      <div
                        className="videos-carousel__play-placeholder"
                        onClick={() => this.handleClick(videoItem, index)}
                      >
                        <div className="videos-carousel__icon-container">
                          <i className="icon icon-play" />
                        </div>
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    );
  }
}

VideoGallery.defaultProps = {
  videos: [],
};

VideoGallery.propTypes = {
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      main_image: PropTypes.string,
      thumb_image: PropTypes.string,
    }),
  ),
};
